import Subheading from "./Subheading/Subheading";
import EventCards from "./EventCards/EventCards";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useMatch, useRouter } from "@tanstack/react-location";
import "swiper/css/bundle";
import Footer from "../Footer/Footer";
import "viewerjs/dist/viewer.css";
import Viewer from "viewerjs";

function Events() {
  const { data } = useMatch();
  const router = useRouter();

  const changeDateFormat = (date) => {
    if (!date) return "";
    let [year, month, day] = date.substring(0, 10).split("-");
    return `${day}-${month}-${year}`;
  };

  // Handle year-wise data grouping
  const year_wise_data =
      Array.isArray(data?.events) && data.events.length > 0
          ? data.events.reduce((acc, item) => {
            let d = new Date(item.date);
            let fullYear = d.getFullYear();
            if (!acc[fullYear]) {
              acc[fullYear] = [];
            }
            acc[fullYear].push(item);
            return acc;
          }, {})
          : {};

  const sortedYears = Object.keys(year_wise_data).sort().reverse();

  if (router.pending) {
    return (
        <div className="flex items-center justify-center h-screen w-screen">
          <div className="w-20 h-20 border-t-4 border-b-4 border-blue-500 rounded-full animate-spin"></div>
        </div>
    );
  }

  return (
      <div className="events-page">
        {/* --- Upcoming Events --- */}
        {data?.upcomingEvents?.length > 0 ? (
            <div className="section-bg pt-[14vh] h-fit w-full">
              <Subheading title="Upcoming Events" />
              <Swiper
                  modules={[Navigation, Pagination, Scrollbar, A11y]}
                  spaceBetween={50}
                  slidesPerView={1}
                  navigation
                  pagination={{ clickable: true }}
              >
                <div id="gallery_image_container">
                  {data.upcomingEvents.map(
                      ({ title, mainImage, description, date, location }, index) => (
                          <SwiperSlide key={index}>
                            <EventCards
                                title={title}
                                coverImage={mainImage.asset.url}
                                description={description[0].children[0].text}
                                date={changeDateFormat(date)}
                                location={location}
                                buttonText="Register Now!"
                                background="rgba(25, 36, 68, 0.6)"
                            />
                          </SwiperSlide>
                      )
                  )}
                </div>
              </Swiper>
            </div>
        ) : (
            <div className="pb-[4rem]"></div>
        )}

        {/* --- Past Events Year-wise --- */}
        {sortedYears.length > 0 && (
            <div className="pt-16 px-4">
              <div className="text-center mb-10">
                <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-gray-900 dark:text-white">
                  OUR EVENTS
                </h2>
                <p className="mt-2 text-gray-500">Explore our events year by year</p>
              </div>

              {sortedYears.map((year, ind) => {
                const sectionId = `gallery_image_container_${year}`;
                return (
                    <div key={ind} className="mb-16">
                      {/* Custom styled year heading */}
                      <h3 className="text-2xl sm:text-3xl font-semibold text-blue-700 dark:text-blue-400 mb-6 text-center">
                        {year}
                      </h3>

                      <div id={sectionId} className="space-y-10">
                        {year_wise_data[year].map(
                            (
                                {
                                  title,
                                  mainImage,
                                  description,
                                  date,
                                  location,
                                  eventPics,
                                },
                                index
                            ) => (
                                <div id={title} key={index}>
                                  <EventCards
                                      title={title}
                                      coverImage={mainImage.asset.url}
                                      description={description[0].children[0].text}
                                      date={changeDateFormat(date)}
                                      location={location}
                                      clickfunc={() => {
                                        if (eventPics?.length > 0) {
                                          new Viewer(document.getElementById(title), {
                                            title: [0, () => ""],
                                          });
                                        }
                                      }}
                                  />
                                  <div className="hidden">
                                    {eventPics?.map((val, index) => (
                                        <img key={index} src={val.asset.url} alt="Event" />
                                    ))}
                                  </div>
                                </div>
                            )
                        )}
                      </div>
                    </div>
                );
              })}
            </div>
        )}

        <Footer />
      </div>
  );
}
export default Events;
